import React, {
	Component
} from 'react';
import { store } from '../stores/mainStore';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { ButtonMover } from './Buttons';
import { integration } from '../integration';
import { Localize } from './Localize';
import { Sprite } from './Sprite';

const ConnectMsg = styled.div`
	font-size: 4vw;
	line-height: 1.1em;
	top: -1vw;
	& span {
		color: white;
		text-shadow: 0.3vw 0.3vw 0.1vw #24377b, -0.3vw -0.3vw 0.1vw #24377b, 0.3vw -0.3vw 0.1vw #24377b, -0.3vw 0.3vw 0.1vw #24377b;
	}
	@media (min-aspect-ratio: 9/15){
		font-size: 2.4vw;
	}
`

const LoginBody = styled.div`
	text-align: center;
	font-size: 0;
	color: white;
	display: flex;
	flex-direction: column;
`

const Box = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 68vw;
	background-size: contain;
	background-repeat: no-repeat;
	box-sizing: border-box;
	padding-top: 16vw;
	@media (min-aspect-ratio: 9/15){
		width: 60vw;
		height: 40.8vw;
		padding-top: 9.5vw;
	}
`

const DynBox = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	box-sizing: border-box;
	background-color: fuchsia;
	padding: 5vw 0 4.5vw;
	background: rgb(243,186,100);
	background: linear-gradient(0deg, rgba(243,186,100,1) 0%, rgba(245,207,105,1) 100%);
	border-radius: 2vw;
	border-bottom: 1vw solid #AF5B2E;
	@media (min-aspect-ratio: 9/15){
		width: 60vw;
	}
`

@observer
export class Login extends Component {
	splashEventSent = false;

	@observable inProgress = false;
	timeout = 0;

	componentWillUnmount(){
		store.getLobbyData();
	}

	openProfile = () => {
		store.showProfile = true;
	}

	linkAppleSignIn(){
		window.manager.playAudio("poopPop");
		this.inProgress = true;
		this.timeout = setTimeout(() => this.inProgress = false, 2000);
		integration.postAnalyticsEvent('press_Apple_Login', 'ftue');
		if(store.user.appleId){
			store.user.loginMethod = 'apple';
		} else {
			window.WrapperApp.postMessage('apple-login');
		}
	}

	linkFacebook(){
		window.manager.playAudio("poopPop");
		this.inProgress = true;
		this.timeout = setTimeout(() => this.inProgress = false, 2000);
	 	integration.postAnalyticsEvent('press_FB_Connect', 'ftue');
		window.WrapperApp.postMessage('fblogin');
	}

	acceptTerms(){
		// if(store.phaserReady)
		window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent('press_continue_accept_terms', 'ftue');
		window.setPersistentStorage('acceptedTosId', store.currentTosId);
		store.acceptedTosId = store.currentTosId;
	}

	confirmGuest() {
		// if(store.phaserReady)
		integration.postAnalyticsEvent('press_play_as_guest', 'ftue');
		window.manager.playAudio("poopPop");
		this.inProgress = true;
		this.timeout = setTimeout(() => this.inProgress = false, 2000);
		store.user.loginConfirmed = true;
	}

	state = {
		preloading: true,
		iframe: ""
	};

	render(){


		const boxUrl = localStorage.getItem('welcomeBack') ? `/assets/languages/${store.settings.language}/splash_box_welcome_back.png` : `/assets/languages/${store.settings.language}/splash_box_welcome.png`;
		const BoxToUse = this.props.noText ? DynBox : Box;
		return (
			<LoginBody>
				<BoxToUse
					style={{
						paddingTop: this.props.noText ? '6vw' : null,
						backgroundImage: this.props.noText ? '' : `url("${boxUrl}")`
					}}
				>
					{store.isIOS && !store.user.apple.isConnected && (
						<ButtonMover onClick={() => {this.linkAppleSignIn();}}>
							<Sprite w={100} unit="%" sprite="splash_btn_apple_heart.png" path="/assets/languages/" localize/>
						</ButtonMover>
					)}
					{!store.user.facebook.isConnected && <ButtonMover onClick={() => {this.linkFacebook();}}>
						<Sprite w={100} unit="%" sprite="splash_btn_fb_heart.png" path="/assets/languages/" localize/>
					</ButtonMover>}
					<ButtonMover onClick={() => { this.confirmGuest(); }}>
						{store.user.facebook.isConnected || store.user.apple.isConnected ? (
							<Sprite w={100} unit="%" sprite="splash_btn_play.png" path="/assets/languages/" localize/>
						) : (
							<Sprite w={100} unit="%" sprite="splash_keep_playing.png" path="/assets/languages/" localize/>
						)}
					</ButtonMover>
					<ConnectMsg>
						{store.user.facebook.isConnected && <p>
							<Localize p="already-connected-fb" />
						</p>}
						{store.user.apple.isConnected && <p>
							<Localize p="already-logged-in-apple" />
						</p>}
					</ConnectMsg>
				</BoxToUse>
			</LoginBody>
		);
	}
}
